<template>
<div class="chapter">
<div class="inner_page">
<p class="p15">This book is dedicated to all those who thirst for justice, both here on earth and in heaven. May the central message of God be the only thing his followers trumpet!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?39aca07a